<!--
 * COPYRIGHT Transtron Inc 2023
 *
 * 機能名：オプション機能設定画面
 *
 * 作成者：2025/10/15 ノア）許
 * 最終修正者：2025/10/15 ノア）許
 *
 -->
<template>
  <div class="tti-main-view">
    <!-- ヘッダー -->
    <section>
      <nav class="tti-main-header-shadow">
        <div class="pull-left">
          <el-button
            class="backButton"
            @click="onBackButtonClick"
            v-tooltip="{
              content: `${$t('gpsTracker.tooltipCommon.companyInfo.back')}`,
              placement: 'bottom-start',
              delay: { show: 1000, hide: 0 }
            }"
          >
            <tti-svg-icon icon-name="wo_034"></tti-svg-icon>
          </el-button>
          <div class="tti-viewTitle">
            <tti-svg-icon icon-name="wo_008"></tti-svg-icon>
            <span>{{ $t('gpsTracker.companyInfo.setOpTitle') }}</span>
          </div>
        </div>
      </nav>
    </section>
    <!-- テーブル -->
    <section class="tti-padding-content">
      <div class="tti-lr-container">
        <div class="left">
          <div class="content">
            <div>{{ $t('gpsTracker.companyInfo.itpConnectConfigTxt') }}</div>
            <div>{{ $t('gpsTracker.companyInfo.apiConnectTxt') }}</div>
          </div>
        </div>
        <div class="right">
          <div>
            <el-form
              label-width="130px"
              label-position="left"
              class="tti-form"
              ref="form"
              size="mini"
              :model="companyInfoData"
            >
              <div class="content">
                <div class="main-eigyousyou-info">
                  <div class="tti-form-block">{{ $t('gpsTracker.companyInfo.itpConnectConfigTxt') }}</div>
                  <div class="tti-form-child tti-form-child-level-1">
                    <!-- ITP連携会社配置フラグ -->
                    <el-form-item
                      :label="$t('gpsTracker.companyInfo.itpConnectConfigFlag')"
                      prop="itpConnectConfigFlag"
                    >
                      <!-- ITP-WebService連携先設定 -->
                      <div class="itp-connect-set-remarks">
                        <el-checkbox
                          v-model="companyInfoData.itpConnectConfigFlag"
                          :true-label="'1'"
                          :false-label="'0'"
                          class="checkbox"
                        >
                        </el-checkbox>
                        <span>{{ $t('master.corporate.itpConnectSet') }}</span>
                      </div>
                    </el-form-item>

                    <!-- 有効期間 -->
                    <div class="data-recover-date-picker">
                      <el-form-item
                        :label="$t('gpsTracker.companyInfo.itpOpPeriod')"
                        prop="datePicker"
                        class="date-picker"
                      >
                        <el-date-picker
                          v-model="companyInfoData.itpConnectStartDate"
                          type="date"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          :editable="false"
                          :clearable="true"
                          :picker-options="pickerOptions"
                          size="small"
                          v-tooltip="{
                            content: `${$t('gpsTracker.tooltipCommon.toolDataRecovery.datePeriod', [
                              $t('gpsTracker.dataRecovery.recoverStartDate')
                            ])}`,
                            placement: 'bottom-start',
                            delay: { show: 1000, hide: 0 }
                          }"
                        ></el-date-picker>

                        <span class="conn">{{ '~' }}</span>
                        <el-date-picker
                          v-model="companyInfoData.itpConnectEndDate"
                          type="date"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          :editable="false"
                          :clearable="true"
                          :picker-options="pickerOptions"
                          size="small"
                          v-tooltip="{
                            content: `${$t('gpsTracker.tooltipCommon.toolDataRecovery.datePeriod', [
                              $t('gpsTracker.dataRecovery.recoverEndDate')
                            ])}`,
                            placement: 'bottom-start',
                            delay: { show: 1000, hide: 0 }
                          }"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="tti-form-block">{{ $t('gpsTracker.companyInfo.apiConnectTxt') }}</div>
                  <div class="tti-form-child tti-form-child-level-1">
                    <!-- API連携 -->
                    <el-form-item
                      :label="$t('gpsTracker.companyInfo.apiConnectConfigFlag')"
                      prop="apiConnectConfigFlag"
                    >
                      <div class="itp-connect-set-remarks">
                        <el-checkbox
                          v-model="companyInfoData.apiConnectConfigFlag"
                          :true-label="'1'"
                          :false-label="'0'"
                          class="checkbox"
                        >
                        </el-checkbox>
                        <span>{{ $t('master.corporate.apiConnectSet') }}</span>
                      </div>
                    </el-form-item>

                    <!-- 有効期間 -->
                    <div class="data-recover-date-picker">
                      <el-form-item
                        :label="$t('gpsTracker.companyInfo.apiOpPeriod')"
                        prop="datePicker"
                        class="date-picker"
                      >
                        <el-date-picker
                          v-model="companyInfoData.apiConnectStartDate"
                          type="date"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          :editable="false"
                          :clearable="true"
                          :picker-options="pickerOptions"
                          size="small"
                          v-tooltip="{
                            content: `${$t('gpsTracker.tooltipCommon.toolDataRecovery.datePeriod', [
                              $t('gpsTracker.dataRecovery.recoverStartDate')
                            ])}`,
                            placement: 'bottom-start',
                            delay: { show: 1000, hide: 0 }
                          }"
                        ></el-date-picker>

                        <span class="conn">{{ '~' }}</span>
                        <el-date-picker
                          v-model="companyInfoData.apiConnectEndDate"
                          type="date"
                          format="yyyy/MM/dd"
                          value-format="yyyy/MM/dd"
                          :editable="false"
                          :clearable="true"
                          :picker-options="pickerOptions"
                          size="small"
                          v-tooltip="{
                            content: `${$t('gpsTracker.tooltipCommon.toolDataRecovery.datePeriod', [
                              $t('gpsTracker.dataRecovery.recoverEndDate')
                            ])}`,
                            placement: 'bottom-start',
                            delay: { show: 1000, hide: 0 }
                          }"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </div>
            </el-form>
            <div class="tti-middle-area">
              <div class="tti-bottom-left-area"></div>
              <div class="tti-bottom-right-area">
                <!-- 取消-->
                <el-button
                  class="tti-btn-default tti-btn-001"
                  @click="onCancelButtonClick"
                  v-tooltip="getTooltip(tooltipType.cancel)"
                  ><tti-svg-icon icon-name="su_005"></tti-svg-icon>{{ $t('buttons.cancel') }}</el-button
                >
                <!-- 保存 -->
                <el-button
                  class="tti-btn-default tti-btn-001"
                  @click="onSaveButtonClick"
                  v-tooltip="getTooltip(tooltipType.save)"
                >
                  <tti-svg-icon icon-name="su_002"></tti-svg-icon>{{ $t('buttons.save') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'

import TOOL_COMPANY_BASE from '@/views/companyEditTool/TOOL_COMPANY_BASE.vue'
import { i18n } from '@/locales'
import { ToolCompanyMasterData, ToolCompanyDetailGetParam, ToolOptionSetParam } from '@/models'
import { getCompanyDetail, setConnectOptionInfo } from '@/store/apis'
import { msgBoxService } from '@/commons/services/msgBoxService'
import { cloneDeep } from 'lodash'
import helperService from '@/service/helperService'
import config from '@/config/config'
import { pickerOptionsPast } from '@/utils/dateUtils'

@Component({
  name: 'TOOL_COMPANY_OPTION_SET'
})
export default class TOOL_COMPANY_OPTION_SET extends TOOL_COMPANY_BASE {
  /**
   * フォームのref
   */
  @Ref('form') readonly formRef!: Form

  /**
   * タイムセレクタをクリックしたときの処理
   */
  pickerOptions = pickerOptionsPast

  /**
   * 画面ID
   */
  pageId = 'TOOL_COMPANY_OPTION_SET'

  /**
   * 会社情報ID
   */
  companyId = ''

  /**
   * 会社情報
   */
  companyInfoData: ToolCompanyMasterData = {
    id: '',
    companyCode: '',
    companyName: '',
    companyPrefix: '',
    idUpperLimit: '50',
    terminalUpperLimit: '1000',
    managementTargetShowName: '管理対象',
    businessOfficeId: '',
    businessOfficeName: '本社',
    location: '',
    tel: '',
    mail: '',
    itpConnectConfigFlag: '',
    itpConnectStartDate: '',
    itpConnectEndDate: '',
    apiConnectConfigFlag: '',
    apiConnectStartDate: '',
    apiConnectEndDate: ''
  }

  /**
   * 古いデータ
   */
  oldData: ToolCompanyMasterData = cloneDeep(this.companyInfoData)

  /**
   * インスタンスがマウントされたちょうど後にフック処理
   *
   * @returns {void}
   */
  async mounted(): Promise<void> {
    this.$log.debug('TOOL_COMPANY_OPTION_SET > mounted')
    this.companyId = this.$route.query.companyId as string
    this.fetchCompanyDetail()
    this.formRef.clearValidate()
  }

  /**
   * 会社情報詳細を取得する
   */
  async fetchCompanyDetail(): Promise<void> {
    if (!this.companyId) {
      return
    }
    const param = {
      companyId: this.companyId
    } as ToolCompanyDetailGetParam

    const res = await getCompanyDetail(param)

    this.companyInfoData = { ...res }

    this.oldData = cloneDeep(this.companyInfoData)
  }

  onValidFlagChange(): void {
    this.formRef.clearValidate()
  }

  /**
   * 取消ボタンをクリックした時の処理。
   *
   * @returns {void}
   */
  onCancelButtonClick(): void {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET >  onCancelButtonClick`)
    if (!helperService.isObjectDataChanged(this.oldData, this.companyInfoData)) {
      this.formRef.clearValidate()
      msgBoxService.info(i18n.t('messages.masterCommon.dataNotChanged').toString())
      return
    }

    const confirmCallback = () => {
      this.formRef.clearValidate()
      this.companyInfoData = {
        ...this.oldData
      }
    }

    msgBoxService.confirm(i18n.t('messages.masterCommon.cancelConfirm').toString(), confirmCallback)
  }

  /**
   * 保存ボタンをクリックした時の処理
   *
   * @returns {void}
   */
  onSaveButtonClick(): void {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET >  onSaveButtonClick`)

    if (!this.saveDataAfter.name) {
      this.saveDataAfter = async () => {
        this.oldData = cloneDeep(this.companyInfoData)

        msgBoxService.info(i18n.t('messages.masterCommon.dataSaved').toString())
      }
    }

    this.formRef.validate(valid => {
      if (!valid) return
      this.saveData()
    })
  }

  /**
   * 遷移前の前処理
   *
   * @returns {Promise<boolean>} 処理結果ステータス
   */
  async saveDataPrepare(): Promise<boolean> {
    try {
      this.formRef.validate(valid => {
        if (!valid) return false
        this.saveData()
      })
      return true
    } catch {
      return false
    }
  }

  /**
   * 保存ボタンをクリックした時の処理
   *
   * @returns {Promise<boolean>} 保存結果
   */
  async saveData(): Promise<boolean> {
    try {
      if (!helperService.isObjectDataChanged(this.oldData, this.companyInfoData)) {
        msgBoxService.info(i18n.t('messages.masterCommon.dataNotChanged').toString())
        return false
      }
      await this.doUpdateCompanyInfo()

      await this.saveDataAfter()
      return true
      /* eslint-disable  @typescript-eslint/no-unused-vars */
      /* eslint-disable  @typescript-eslint/no-explicit-any */
    } catch (e: any) {
      if (e?.data?.common?.code === 'E00101') {
        this.$router.push(config.toolMenu.companyInfo)
        return false
      }
      this.$log.debug(`TOOL_COMPANY_OPTION_SET > saveTableData: e=`, e)
      throw e
    }
  }

  /**
   * 保存後に実行したい操作。
   *
   * @returns {void}
   */
  async saveDataAfter(): Promise<void> {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET > saveDataAfter`)
    msgBoxService.info(i18n.t('messages.masterCommon.dataSaved').toString())

    this.oldData = cloneDeep(this.companyInfoData)
  }

  /**
   * 会社情報詳細編集。
   *
   * @returns {void}
   */
  async doUpdateCompanyInfo(): Promise<void> {
    const companyParam = {
      id: this.companyInfoData.id,
      itpConnectConfigFlag: this.companyInfoData.itpConnectConfigFlag,
      itpConnectStartDate: this.companyInfoData.itpConnectStartDate,
      itpConnectEndDate: this.companyInfoData.itpConnectEndDate,
      apiConnectConfigFlag: this.companyInfoData.apiConnectConfigFlag,
      apiConnectStartDate: this.companyInfoData.apiConnectStartDate,
      apiConnectEndDate: this.companyInfoData.apiConnectEndDate
    } as ToolOptionSetParam

    this.$log.debug(`TOOL_COMPANY_OPTION_SET >  doUpdateCompanyInfo `, companyParam)
    try {
      await setConnectOptionInfo(companyParam)
    } catch (e) {
      Vue.$log.debug('TOOL_COMPANY_OPTION_SET > doUpdateCompanyInfo: e=', e)
      throw e
    }
  }

  /**
   * 戻るボタンをクリックした時の処理。
   *
   * @returns {void}
   */
  onBackButtonClick(): void {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET > onBackButtonClick`)

    const doBack = () => {
      this.doBack()
    }

    this.handMove(doBack)
  }

  /**
   * 前画面へ戻る
   *
   * @returns {void}
   */
  doBack(): void {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET > doBack`)
    this.$router.back()
  }

  /**
   * 遷移する時の処理。
   *
   * @param {any} next 遷移処理
   * @param {boolean} needReset 保存失敗またはキャンセル時に、Routeをリセットするかどうか
   * @returns {void}
   */
  // eslint-disable-next-line
  handMove(next: any, needReset = false): void {
    this.$log.debug(`TOOL_COMPANY_OPTION_SET > handMove`)
    if (!next) {
      return
    }

    if (!helperService.isObjectDataChanged(this.oldData, this.companyInfoData)) {
      next()
      return
    }

    const confirmCallback = async () => {
      this.$log.debug(`TOOL_COMPANY_OPTION_SET > handMove > confirmCallback`)
      try {
        this.saveDataAfter = async () => {
          msgBoxService.info(i18n.t('messages.masterCommon.dataSaved').toString(), next)
        }

        if (!(await this.saveDataPrepare()) && needReset) {
          this.$router.forward()
        }
      } catch (e) {
        this.$log.debug(`TOOL_COMPANY_OPTION_SET > handMove`, e)
        if (needReset) {
          this.$router.forward()
        }
        throw e
      }
    }

    const rejectCallback = () => {
      this.$log.debug(`TOOL_COMPANY_OPTION_SET > handMove > rejectCallback`)
      next()
    }

    const cancelCallback = () => {
      this.$log.debug(`TOOL_COMPANY_OPTION_SET > handMove > cancelCallback`)
      if (!needReset) {
        return
      }

      this.$router.forward()
    }

    msgBoxService.confirmWithCancel(
      i18n.t('messages.masterCommon.saveConfirmWhenChanged').toString(),
      confirmCallback,
      rejectCallback,
      cancelCallback
    )
  }
}
</script>

<style lang="scss" scoped>
::v-deep .tti-bottom-right-area .tti-btn-default {
  margin-right: 0 !important;
}

.tti-main-header-shadow {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.tti-form-child {
  margin: 18px 0;
}

.tti-form-child-level-1,
.tti-form-child-level-2 {
  margin-left: 32px;
}

::v-deep .tti-form-child-level-2 label {
  width: 200px;
  text-align: left;
}

.left {
  width: calc(((100% - 24px) * 1) / 5);

  .content {
    padding: 16px 24px;
    background-color: $C04;
  }

  .content div {
    margin: 10px 0;
  }
}

.right {
  width: calc(((100% - 24px) * 4) / 5);
  overflow: auto;

  .content {
    padding: 16px;
  }
}

.main-eigyousyou-info {
  margin-top: 20px;
  height: 675px;
}

.company-base-info {
  margin-top: 15px;
}

::v-deep .input {
  width: 360px;
}

.tti-form-block {
  border-bottom: $C05 solid 1px;
  margin-bottom: 30px;
  padding-bottom: 5px;
}

.tti-middle-area {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-right: 17px;

  .tti-bottom-left-area,
  .tti-bottom-right-area {
    display: flex;
    align-items: center;
  }
}

.itp-connect-set-remarks {
  font-size: 14px;
}

.itp-connect-set-item {
  margin-top: 10px;
  margin-left: -110px;
}

.itp-code-item {
  display: inline-block;
  margin-bottom: 5px;
}

.button-group {
  margin-top: 10px;
}

.itp-code-input {
  width: 150px;
  margin-right: 15px;
}

.checkbox {
  margin-right: 5px;
}

.conn {
  font-size: large;
  margin-left: 10px;
  margin-right: 10px;
}

.data-recover-date-picker {
  display: flex;

  .date-picker {
    display: flex;
    margin-top: 20px;
    margin-left: 6px;
  }

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form-item--mini {
  margin-left: 6px !important;
}
</style>
